<template>
  <img
    src="~/assets/icon/icon-close-gray.svg"
    alt=""
  />
</template>
